import React from 'react';
import { getAccentChipStyle } from './types';

interface ProfileCardSkillsProps {
  skills: string[];
  showSkills: boolean;
  colorScheme: string;
  variant: 'preview' | 'full';
  /** HR brand override — when set, skill chips derive from the brand so they
   *  coordinate with the hero banner and page background (one accent source). */
  branding?: { primaryColor: string; secondaryColor: string };
  t: (key: string) => string;
}

const ProfileCardSkills: React.FC<ProfileCardSkillsProps> = ({
  skills,
  showSkills,
  colorScheme,
  variant,
  branding,
  t
}) => {
  if (!showSkills || !skills || skills.length === 0) return null;

  const chip = getAccentChipStyle(colorScheme, branding);
  const isPreview = variant === 'preview';

  if (isPreview) {
    return (
      <div className="mt-2">
        <h4 className="text-[10px] font-semibold text-foreground mb-1 uppercase tracking-wide">{t('Skills')}</h4>
        <div className="flex flex-wrap gap-1">
          {skills.slice(0, 4).map((skill, index) => (
            <span
              key={index}
              className={`px-1.5 py-0.5 ${chip.className} rounded text-[9px] font-medium`}
              style={chip.style}
            >
              {skill}
            </span>
          ))}
          {skills.length > 4 && (
            <span className="px-1.5 py-0.5 bg-muted text-muted-foreground rounded text-[9px] font-medium">
              +{skills.length - 4}
            </span>
          )}
        </div>
      </div>
    );
  }

  // Full variant
  return (
    <div className="mb-6">
      <h3 className="text-sm font-semibold text-foreground mb-3 uppercase tracking-wide">{t('Skills')}</h3>
      <div className="flex flex-wrap gap-2">
        {skills.map((skill, index) => (
          <span
            key={index}
            className={`px-3 py-1.5 ${chip.className} rounded-full text-sm font-medium`}
            style={chip.style}
          >
            {skill}
          </span>
        ))}
      </div>
    </div>
  );
};

export default ProfileCardSkills;
